export default __webpack_public_path__ + "static/media/cheese.da6c51a8.png";